import React from 'react';
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import ButtonTransparent from "@atoms/button.transparent";
import Icon from "@atoms/icon";
import EyeIcon from '@icons/eye.svg';
import EditIcon from '@icons/edit.svg'
import TrashIcon from '@icons/trash.svg'

const PropertyManageModal = ({show, setShow, setShowDeleteModal, property_id, property_status = '', propertyUrl, propertyMediaCount, handleShowProperty}) => {

    return (
        <ModalLayout show={show} setShow={() => setShow(false)} modalDialogClass="modal-sm report-modal" dialogBodyClassName="px-0">
            <div className="text-center mt-8 mt-lg-0">
                <h3 className="h2">مدیریت آگهی</h3>

                <Card className="px-24 px-lg-32 pt-24 pb-40 pb-md-0">
                    {
                        (property_status === 'pending') ?
                            <a href={propertyUrl} onClick={(e) => handleShowProperty(e, propertyUrl, propertyMediaCount)} className="d-flex align-items-center">
                                <Icon width="20" height="20" className="ml-24"><EyeIcon/></Icon>
                                <span className="manage-items w-100 text-right py-16">پیش‌نمایش</span>
                            </a>
                            : ''
                    }

                    <a href={'/properties/' + property_id + '/edit'} className="d-flex align-items-center">
                        <Icon width="20" height="20" className="ml-24"><EditIcon/></Icon>
                        <span className="manage-items w-100 text-right py-16">ویرایش</span>
                    </a>

                    <ButtonTransparent onClick={() => setShowDeleteModal(true)} className="d-flex align-items-center w-100">
                        <Icon width="20" height="20" className="ml-24"><TrashIcon/></Icon>
                        <span className="manage-items w-100 text-right py-16">حذف</span>
                    </ButtonTransparent>
                </Card>
            </div>
        </ModalLayout>
    );
};

export default React.memo(PropertyManageModal);

// styles

const Card = styled.div`
    a {
        &:first-child {
            .manage-items {
                border-top: none;
            }
        }
    }
    
    .manage-items {      
        border-top: 1px solid ${props => props.theme.gray200};        
    }
`;
